import { gemmiciApiServiceClient } from "../../core/apis/gemmiciApiService/AxiosIntance";

export default {
  userCreateAPI(userData) {
    return gemmiciApiServiceClient.post("auth/users/", {
      username: userData.username,
      email: userData.email,
      password: userData.password,
      re_password: userData.confirmPassword
    });
  },
  userActivateAPI(uid, token) {
    return gemmiciApiServiceClient.post("auth/users/activation/", {
      uid: uid,
      token: token
    });
  },
  userResendActivationEmailAPI(email) {
    return gemmiciApiServiceClient.post("auth/users/resend_activation/", {
      email: email
    });
  },
  retrieveUserAPI() {
    return gemmiciApiServiceClient.get("auth/users/me/");
  },
  updateUserAPI(data) {
    return gemmiciApiServiceClient.put("auth/users/me/", {
      username: data.username,
      email: data.email,
      first_name: data.firstName
    });
  },
  userDeleteAPI(password) {
    return gemmiciApiServiceClient.delete("auth/users/me/", {
      current_password: password
    });
  },
  setPasswordAPI(passwordData) {
    return gemmiciApiServiceClient.post("auth/users/set_password/", {
      new_password: passwordData.new_password,
      current_password: passwordData.current_password
    });
  },
  resetPasswordAPI(email) {
    return gemmiciApiServiceClient.post("auth/users/reset_password/", {
      email: email
    });
  },
  resetPasswordConfirmationAPI(passwordConfirmationData) {
    return gemmiciApiServiceClient.post("auth/users/reset_password_confirm/", {
      uid: passwordConfirmationData.uid,
      token: passwordConfirmationData.token,
      new_password: passwordConfirmationData.new_password,
      re_new_password: passwordConfirmationData.new_password,
    });
  },
  JWTCreateAPI(authenticationData) {
    return gemmiciApiServiceClient.post("auth/jwt/create/", {
      username: authenticationData.username,
      password: authenticationData.password
    });
  },
  JWTRefreshAPI(refreshToken) {
    return gemmiciApiServiceClient.post("auth/jwt/refresh/", {
      refresh: refreshToken
    });
  },
  JWTVerifyAPI(token) {
    return gemmiciApiServiceClient.post("auth/jwt/verify/", {
      token: token
    });
  }
};
